import React from 'react';
import Background from '../../assets/background_pc@2x.png';
import Line from '../../assets/line_pc@2x.png';
import NoAuth from '../../assets/no_auth_pc@2x.png';
import './index.scss';
import { FileInfoBO, Permission } from '../../model/BO/FileBO';
import { RequestStatus } from '../../model/BO/CommonBO';
import { getFileTypeByName, bytesToSize, getLengthValidateFileName } from '../../utils/FileUtil';
import { expireMap } from '../../service/FileService';

interface PublicSharePCProps {
  fileInfo: FileInfoBO | null;
  noPermission: boolean;
  fetchStatus: RequestStatus;
  allowPreview: boolean;
  handleRetry: () => void;
  handleDownload: () => void;
  handlePreview: () => void;
}

export default class PublicSharePC extends React.PureComponent<PublicSharePCProps> {
  public renderContent() {
    const { fileInfo, allowPreview, noPermission } = this.props;
    if (noPermission) {
      return (
        <img src={NoAuth} className="bg center-content no-auth-bg" alt="无权限" title="无权限" />
      );
    }
    if (!fileInfo) {
      return null;
    }
    if (fileInfo.expire || !fileInfo.shareOpen) {
      return (
        <img src={NoAuth} className="bg center-content no-auth-bg" alt="无权限" title="无权限" />
      );
    }
    const type = getFileTypeByName(fileInfo.fileName);
    const fileName = getLengthValidateFileName(fileInfo.fileName, 55);
    if (allowPreview) {
      return null;
    }
    return (
      <div>
        <img src={Background} title="背景" alt="背景" className="bg center-content" />
        <div className="file-info center-content">
          <img
            className="file-type"
            src={require(`../../assets/fileIcon/file_type_${type}.svg`)}
            alt={type}
            title={type}
          />
          <div className="title" title={fileName}>
            {fileName}
          </div>
          <div className="sub-info">
            <span>
              分享者:
              <span className="share-name" title={fileInfo.shareName}>
                {fileInfo.shareName}
              </span>
            </span>
            <span className="expire-time">有效期: {expireMap.get(fileInfo.expireType)}</span>
            <span>文件大小: {bytesToSize(fileInfo.size)}</span>
          </div>
          <div style={{ textAlign: 'center' }}>
            {allowPreview ? (
              <button className="btn btn-primary" onClick={this.props.handlePreview}>
                打开
              </button>
            ) : null}
            {fileInfo.permission === Permission.DOWNLOAD ||
            fileInfo.permission === Permission.EDIT ? (
              <button className="btn btn-default" onClick={this.props.handleDownload}>
                下载
              </button>
            ) : null}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { fetchStatus } = this.props;
    return (
      <div className="share-container share-pc-container">
        <img src={Line} title="line" alt="line" className="bg-line" />
        {fetchStatus === RequestStatus.FAILED ? (
          <div className="error">
            加载失败，
            <a className="retry" onClick={this.props.handleRetry}>
              请重试
            </a>
          </div>
        ) : fetchStatus === RequestStatus.PENDING ? (
          <div className="loading">加载中...</div>
        ) : (
          this.renderContent()
        )}
      </div>
    );
  }
}
